"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleMakeListForYear = void 0;
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const VehicleMake_1 = require("../models/VehicleMake");
const PATH = 'vehicle-makes';
async function vehicleMakeListForYear(year, firestore) {
    const results = await firestore.list(PATH, { where: [['years', 'array-contains', year]] });
    const makes = results.map(result => (0, VehicleMake_1.vehicleMakeDeserialize)(result.value, result.id));
    return (0, sortBy_1.default)(makes, vehicle => vehicle.name);
}
exports.vehicleMakeListForYear = vehicleMakeListForYear;
